module.exports = __webpack_public_path__ + "img/Postmodernisme_Helene-Uri.e6096b65.jpg";